
import * as React from "react"
import { sanitizeText } from "@/utils/validation"
import { cn } from "@/lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  sanitizeOnBlur?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, sanitizeOnBlur = false, onBlur, onChange, ...props }, ref) => {
    // Custom blur handler that sanitizes content if enabled
    const handleBlur = sanitizeOnBlur 
      ? (e: React.FocusEvent<HTMLTextAreaElement>) => {
          // Sanitize the content
          const sanitized = sanitizeText(e.target.value);
          if (sanitized !== e.target.value) {
            e.target.value = sanitized;
            // Trigger change event to update any form state
            const event = new Event('input', { bubbles: true });
            e.target.dispatchEvent(event);
          }
          // Call the original onBlur handler if provided
          if (onBlur) onBlur(e);
        }
      : onBlur;
    
    return (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        onBlur={handleBlur}
        onChange={onChange}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
